import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'predefinedEventManagementExperience.list'

const PredefinedEventManagementPredefinedEventListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default PredefinedEventManagementPredefinedEventListSlice
